<template>
  <div id="contractHelperComponentContainer">

    <div class="card text-center">
      <div class="card-header">
        <h4 tabindex="0">Contract Details</h4>
      </div>
      <div class="card-body">

        <div class="row">
          <div class="col">
            <span tabindex="0" class="contractHelperComponentLabel">Contract Number: </span>
            <span tabindex="0" class="contractHelperComponentDataElement">{{ contractInfo.contractNumber }}</span>
          </div>
          <div class="col">
            <span tabindex="0" class="contractHelperComponentLabel">Agency: </span>
            <span tabindex="0" class="contractHelperComponentDataElement">{{ contractInfo.agencyName }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <span tabindex="0" class="contractHelperComponentLabel">Company Name: </span>
            <span tabindex="0" class="contractHelperComponentDataElement">{{ contractInfo.companyName }}</span>
          </div>
          <div class="col">
            <span tabindex="0" class="contractHelperComponentLabel">Company Phone: </span>
            <span tabindex="0" class="contractHelperComponentDataElement">{{ contractInfo.companyPhone }}</span>
          </div>
        </div>

        <div class="row">

          <div class="col">

            <span tabindex="0" class="contractHelperComponentLabel">KO/COR Information: </span>

            <div class="allkoCors">
              <div v-if="contractInfo.koCorList.length > 0">
                <div class="koCorInfoContainer" v-for="koCor in contractInfo.koCorList" :key="koCor.id">

                  <span tabindex="0" class="roleSpan">
                    <strong>{{ koCor.role }}</strong>&nbsp;
                  </span>

                  <span>
                    <TooltipHelper position="top" tooltip-text="Click here to Send an email to this KO/COR">
                      <a class="emaillink" tabindex="0" :href="'mailto:' + koCor.email">{{ koCor.rank }} {{ koCor.email }}</a>;
                    </TooltipHelper>
                  </span>

                </div>
              </div>

              <div v-else>
                <span>No KO(s)/COR(s) associated with this Contract...</span>
              </div>


            </div>

          </div>

        </div>

      </div>
      <div class="card-footer text-muted">
        <!-- <TooltipHelper position="top" tooltip-text="Review/Update this Contract.">
          <a @click="EditContract" href="#">Review/Update Contract</a>
        </TooltipHelper> -->

      </div>
    </div>

  </div>
</template>

<script>
import TooltipHelper from "@/components/dataSupport/TooltipHelper.vue";

export default {
  name: "ContractHelper",
  components: {
    TooltipHelper
  },
  data() {
    return {
      contractInfo: {},
    }
  },
  props: {
    propContractInfo: Object,
  },
  created() {
    //console.log("createing contract helper");
    this.contractInfo = this.propContractInfo;
  },
  mounted() {
  },

  methods: {
    EditContract() {
      alert('edit contract with Id: ' + this.contractInfo.contractId + "; contract number: " + this.contractInfo.contractNumber);
    }
  },
  unmounted() {

    //console.log("force update user contracts table"); 
    this.$forceUpdate();
  }
}
</script>
  
<style scoped>

.emaillink {
    color: #1A1A1A !important;
    text-decoration:underline !important;
}

#contractHelperComponentContainer {
  display: flex;
  width: 85%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
}

#contractHelperComponentContainer .card {
  flex-grow: 1;
  text-align: left;
}

#contractHelperComponentContainer .row {
  text-align: left;
}

#contractHelperComponentContainer .col {
  display: flex;
}

.contractHelperComponentLabel {
  min-width: 180px;
  text-align: right;
  font-weight: bold;
  padding-right: 5px;
}

.koCorInfoContainer {
  display: flex;
}

.card-header {
  background: #8982e6;
  color: white;
}

.card-body {
  background: #D0CDF5;
}

.allkoCors {
  display: flex;
  flex-direction: column;
}

.roleSpan {
  width: 47px;
  padding-right: 5px;
}</style>